"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatusService = void 0;
var proxy_service_1 = require("./proxy.service");
var UserStatusService = /** @class */ (function () {
    function UserStatusService() {
    }
    UserStatusService.getSimple = function () {
        return this.userInfo;
    };
    UserStatusService.loginOut = function () {
        this.clearUserInfo();
    };
    UserStatusService.clearUserInfo = function () {
        this.userInfo = {};
        window.sessionStorage.removeItem('USERINFO');
        proxy_service_1.ProxyService.axios.defaults.headers.common['sid'] = '';
    };
    // 获取用户信息
    UserStatusService.getUserInfo = function () {
        var userObj = window.sessionStorage.getItem('USERINFO');
        userObj = userObj ? JSON.parse(userObj) : userObj;
        if (userObj) {
            this.userInfo = __assign(__assign({}, this.userInfo), userObj);
            this.userInfo['sid'] = userObj['sid'];
            proxy_service_1.ProxyService.axios.defaults.headers.common['sid'] = userObj['sid'];
            if (this.userInfo['loginKey'])
                proxy_service_1.ProxyService.axios.defaults.headers.common['token'] = this.userInfo['loginKey'];
        }
    };
    // 设置用户信息
    UserStatusService.setUserInfo = function (userObj) {
        window.sessionStorage.setItem('USERINFO', JSON.stringify(userObj));
        this.userInfo['sid'] = userObj.sid || '';
        this.userInfo = __assign(__assign({}, this.userInfo), userObj);
        proxy_service_1.ProxyService.axios.defaults.headers.common['sid'] = userObj['sid'];
        if (this.userInfo['loginKey'])
            proxy_service_1.ProxyService.axios.defaults.headers.common['token'] = this.userInfo['loginKey'];
    };
    UserStatusService.userInfo = {
        sid: '',
    };
    return UserStatusService;
}());
exports.UserStatusService = UserStatusService;
